import { useBusinessContext } from '@root/context'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { fetchCountries } from '../constants'

interface UseCountriesOptions {
  enabled?: boolean
}

export const useCountries = ({ enabled = true }: UseCountriesOptions = {}) => {
  const { slug } = useBusinessContext()

  return useQuery({
    queryKey: [slug, 'countries'],
    queryFn: () => fetchCountries({ slug }),
    enabled: Boolean(slug) && enabled,
    ...{
      placeholderData: keepPreviousData,
      staleTime: 6 * 60 * 60 * 1000,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false
    }
  })
}
